export default __webpack_public_path__ + "ede0fd6ef1271ad7fc5ab67e3a6532e0.svg";